import { LinkingOptions } from "@react-navigation/native";

import { RootStackParamList } from "./types";

// React Navigation doesn't decode path params when parsing a URL, but does
// encode them when building one, so an already-encoded param (e.g. an event
// slug with accents) gets double-encoded on navigate unless we decode it here.
const safeDecode = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [],
  config: {
    screens: {
      AuthenticatedFlow: {
        screens: {
          SelectTenant: "select_tenant",
          AccountSetup: "account_setup",
          MainFlow: {
            screens: {
              Home: {
                screens: {
                  DashboardScreen: "",
                  ActivateAll: "activate_all_vouchers",
                },
              },
              MyEvents: {
                screens: {
                  Events: "event",
                  EventDetail: "events/:groupCode",
                  Barcode: "events/:groupCode/barcodes",
                  Guests: "events/:groupCode/guests",
                },
              },
              Schedule: {
                screens: {
                  ScheduleScreen: "schedule",
                  EventAvailablityDetails: "schedule/event_details",
                  SeatSelection: "seats",
                  TflSeatSelection: "seat_map",
                  Reserve: "reserve",
                  PremiumCodeDetails: "inventory_details",
                },
              },
              Account: {
                screens: {
                  AccountScreen: "account",
                  PaymentMethod: "account/payment_method",
                  EditProfile: "account/edit_profile",
                  Settings: {
                    screens: {
                      SettingScreen: "account/settings",
                    },
                  },
                  UpdateBillingInterval: "account/update_billing",
                  AccountDetails: {
                    screens: {
                      AccountDetailsScreen: "account/details",
                    },
                  },
                  Activity: "account/activity",
                  ManageSubscriptions: {
                    screens: {
                      ManageSubscriptionsScreen: "account/manage_subscriptions",
                      SubscriptionDetail:
                        "account/manage_subscriptions/:memberId",
                      AddNewPlan: "account/manage_subscriptions/:memberId/new",
                      AddNewPlanWithPlanPackageId:
                        "account/manage_subscriptions/:memberId/new/:planPackageId",
                    },
                  },
                  UpgradePlans: "account/upgrade_plans",
                  AddMembership: "account/add_membership",
                  MemberCard: "account/member_card",
                  MyGifts: "account/my_gifts",
                },
              },
            },
          },
        },
      },
      LoginFlow: {
        screens: {
          Register: "register/:preSelectedPlanPackageId?",
          Login: "login",
          ForgotPassword: "forgot_password",
          ResetPassword: "reset_password/:encodedEmail",
        },
      },
      ClaimSeats: "claim_seats/:eventCode/:transferCode",
      ClaimGuestPasses: "claim_guest_passes/:eventCode/:transferCode",
      Legal: "legal/:documentName",
      GroupReservation: "group_reservation/:eventCode/:groupCode",
      Shop: "shop/:slug",
      ShopPagePhaseTwo: "new_shop/:slug",
      ShopV3: "shop_v3/:slug/:category?/:product?",
      FinishSignup: "finish_signup/:encodedEmail",
      BallparkAccountNotFound: "ballpark_account_not_found",
      BuyGift: "buy_gift/:planPackageId?",
      TicketBundle: "ticket_bundle/:planPackageId",
      ClaimGift: "claim_gift/:code",
      RsvpsGeneral: {
        path: "rsvp/:eventSlug",
        parse: { eventSlug: safeDecode },
      },
      RsvpsPersonal: {
        path: "rsvp/:eventSlug/:playerId",
        parse: { eventSlug: safeDecode },
      },
      RenewalOptIn: "renewal_opt_in/:token",
      SSOPlayerNotFound: "sso/player-not-found",
    },
  },
};

export default linking;
